<template>
    <div
        :style="{ 'border-color': customColor }"
        :class="{ '-focused': focused, '-error': errors.has(name) }"
        @click="clickHandler"
        class="login-text-input"
    >
        <div class="login-input-row">
            <div
                :style="{ color: customColor }"
                :class="{
                    '-focused': focused,
                    '-filled': value || value === 0,
                    '-error': errors.has(name)
                }"
                class="login-input-label"
            >
                {{ label }}
            </div>
            <input
                :class="{ '-dark': dark }"
                :name="name"
                @keydown.enter="$emit('enter')"
                :autocomplete="autocomplete"
                :placeholder="placeholder"
                :type="type"
                :value="value"
                @blur="focused = false"
                @focus="focused = true"
                @input="onInput"
                ref="input"
            />
            <i
                :style="{ color: customColor }"
                :class="{ '-focused': focused, '-error': errors.has(name) }"
                class="material-icons"
                >{{ icon }}</i
            >
        </div>
    </div>
</template>
<script>
export default {
    props: {
        color: String,
        name: String,
        value: [String, Number],
        type: {
            type: String,
            default: 'text'
        },
        errors: Object,
        label: String,
        autocomplete: {
            type: String,
            default: 'nope'
        },
        placeholder: {
            type: String,
            default: ''
        },
        icon: String,
        dark: Boolean
    },
    data() {
        return {
            focused: false
        }
    },
    computed: {
        customColor() {
            return this.focused ? this.$Utils.colors[this.color] : ''
        }
    },
    methods: {
        clickHandler() {
            this.errors.clear(this.name)
        },
        onInput($event) {
            let value = $event.target.value
            if (value === null) {
                this.$emit('input', value)
                return
            }
            if (this.type === 'number') {
                value = parseInt(value)
            }

            if (this.type === 'price') {
                value = value.replace(',', '.').replace(' ', '')
                let numberRaw = Number(value)
                if (isNaN(numberRaw) === true) {
                    value = 0
                } else {
                    value = Math.round(numberRaw * 100)
                    value = value / 100
                }
            }
            this.$emit('input', value)
        }
    }
}
</script>
<style lang="scss" scoped>
.login-text-input {
    margin-top: 3rem;
    padding: 0.1rem;
    border-bottom: 0.1rem solid $light;
    transition: $ease;
    box-sizing: border-box;

    &.-focused {
        border-color: $accent-blue;
    }
    &.-error {
        border-color: $accent-red;
    }
}
.login-input-label {
    color: $light;
    letter-spacing: 1.25px;
    font-family: $input-family;
    transition: $ease;
    position: absolute;
    pointer-events: none;
    font-size: 1rem;

    &.-focused {
        font-size: 0.9rem;
        color: $accent-blue;
        transform: translateY(-2rem);
    }

    &.-filled {
        font-size: 0.9rem;
        transform: translateY(-2rem);
    }

    &.-error {
        color: $accent-red;
    }
}
.login-input-row {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
}
input {
    flex: 1;
    border: none;
    outline: none;
    padding: 0.6rem 0;
    box-sizing: border-box;
    font-size: 1rem;
    letter-spacing: 1px;
    background: transparent;
    border-radius: $input-radius;
    padding-right: 2rem;
    font-family: $input-family;
    color: var(--color);
    transition: $ease;
    stroke: var(--color);
}
i {
    color: var(--color);
    transition: $ease;
    position: absolute;
    right: 0;

    &.-focused {
        color: $accent-blue;
    }

    &.-error {
        color: $accent-red;
    }
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
    border: none;
    font-family: $input-family;
    -webkit-text-fill-color: var(--color);
    -webkit-text-stroke-color: var(--color);
    -webkit-box-shadow: 0 0 0px 1000px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: var(--color);
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type='number'] {
    -moz-appearance: textfield;
}
</style>
